import { Button } from "@chakra-ui/react/button";
import { useBreakpointValue } from "@chakra-ui/react/hooks";
import { Text } from "@chakra-ui/react/text";

import {
  DrawerBackdrop,
  DrawerBody,
  DrawerContent,
  DrawerRoot,
} from "components/ui/drawer";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";

const StaleDataManager = () => {
  const { colorScheme } = useAppSelector((state) => state.theme);
  const [showOutdatedWarning, setShowOutdatedWarning] = useState(false);
  const isBaseSize = useBreakpointValue(
    { base: true, md: false },
    { ssr: false }
  );

  useEffect(() => {
    if (isBaseSize) {
      let blurredOn: number;

      document.addEventListener("visibilitychange", (event) => {
        if (document.visibilityState === "hidden") {
          blurredOn = Date.now();
        }

        if (document.visibilityState === "visible" && blurredOn) {
          const moreThanFiveSecondsPassed = Date.now() - blurredOn > 60000;
          const isInbox = window.location.pathname.includes("inbox");

          if (isInbox && moreThanFiveSecondsPassed) {
            setShowOutdatedWarning(true);
          }
        }
      });
    }
  }, [isBaseSize]);

  return (
    <DrawerRoot
      open={showOutdatedWarning}
      placement="top"
      onOpenChange={({ open: newIsOpen }) => {
        if (newIsOpen) {
          return;
        }
        setShowOutdatedWarning(false);
      }}
      closeOnInteractOutside={true}
    >
      <DrawerBackdrop />
      <DrawerContent style={{ borderRadius: 0 }}>
        <DrawerBody textAlign="center">
          <Text>
            This application hasn&apos;t updated for a while, so conversations
            might not be current.
          </Text>

          <Button
            colorPalette="gray"
            onClick={() => {
              setShowOutdatedWarning(false);
            }}
            size="sm"
            mt={4}
            variant="ghost"
          >
            Dismiss
          </Button>
          <Button
            colorPalette={colorScheme}
            onClick={() => {
              window.location.reload();
            }}
            size="sm"
            mt={4}
          >
            Refresh
          </Button>
        </DrawerBody>
      </DrawerContent>
    </DrawerRoot>
  );
};

export default StaleDataManager;
